import React from "react";
import {ButtonListCell} from "gd-react";

// Renders an empty cell instead of a greyed button, keeping the column aligned. The column's
// hideOnNoValue hook is unusable here: it mutates the shared column object, so one schedule row
// would collapse the column for every row after it.
class DataRequestActionCell extends React.Component {
    render() {
        if (this.props.hideFor && this.props.hideFor(this.props.object)) {
            return (
                <div className={'list-field' + (this.props.noheader ? ' checkbox' : '')}
                     style={{maxWidth: this.props.maxWidth ? this.props.maxWidth : '250px'}}/>
            );
        }
        return <ButtonListCell {...this.props}/>;
    }
}

export default DataRequestActionCell;
